import React, { FunctionComponent, useState } from 'react';
import CreateFtpIngestForm from './form';
import { IngestSource, Map } from './FtpIngestTypes';
import Row from './row';

interface FtpIngestManagementProps {
  ingestSources: IngestSource[];
  sections: Map;
  collections: Map;
  gettyClient: boolean;
}

type FtpIngestFormProps = FtpIngestManagementProps & { setShowForm: SetStateDispatch<boolean> };

type FtpIngestRowsProps = FtpIngestManagementProps & { setIngestSources: SetStateDispatch<IngestSource[]> };

const FtpIngestFormContainer: FunctionComponent<FtpIngestFormProps> = ({
  collections,
  gettyClient,
  sections,
  setShowForm
}) => (
  <div id="manage-ftp-ingest">
    <div
      className="ftp-ingests--cancel-edit"
      onClick={(): void => setShowForm(false)}
      onKeyPress={(): void => setShowForm(false)}
      role="button"
      tabIndex={0}
    >
      <span className="ftp-ingest-back-indicator bff-arrow-left" />
      <span className="ftp-ingest-back-indicator">{t('Back')}</span>
    </div>
    <CreateFtpIngestForm
      sections={sections}
      collections={collections}
      gettyClient={gettyClient}
    />
  </div>
);

const FtpIngestRows: FunctionComponent<FtpIngestRowsProps> = (props) => {
  const { collections, gettyClient, ingestSources, sections, setIngestSources } = props;
  const widthClass = gettyClient ? "quarter-width" : "third-width";
  return ingestSources.length > 0 ? (
    <>
      <div className="ftp-ingest-description">
        {!gettyClient && (
          <p className="ftp-ingest-description--content">
            {`${t("Ingest assets into Brandfolder using:")} `}
            <strong>sftp://files.brandfolder.io</strong>
            <br />
            <strong>{t('Port 22')}</strong>
          </p>
        )}
      </div>
      <div id="ftp-ingest-list">
        <div className="headers">
          <div className="headers-container">
            <h3 className={widthClass}>{t('Username')}</h3>
            <h3 className={widthClass}>{t('Add to section')}</h3>
            <h3 className={widthClass}>{t('Also add to Collection')}</h3>
            {gettyClient && <h3 className={widthClass}>{t('Ingest URL')}</h3>}
          </div>
        </div>
        {ingestSources.map((source) => (
          <Row
            source={source}
            sections={sections}
            collections={collections}
            key={source.key}
            gettyClient={gettyClient}
            setIngestSources={setIngestSources}
          />
        ))}
      </div>
    </>
  ) : (
    <div id="ftp-ingest-list">
      <span className="no-ftp-ingests-message">
        {BFG.resource.name + t(' does not have any FTP ingests')}
      </span>
    </div>
  );
};

const FtpIngestManagement: FunctionComponent<FtpIngestManagementProps> = (props) => {
  const [showForm, setShowForm] = useState(false);
  const [ingestSources, setIngestSources] = useState(props.ingestSources);
  return (
    <div className="manage-ftp-ingests">
      <div className="header">
        <h2>{t("FTP Ingest")}</h2>
        {!showForm && (
          <button
            type="button"
            className="button primary ftp-ingest-create-button"
            onClick={(): void => setShowForm(!showForm)}
          >
            <span className="bff-plus" style={{ marginRight: "10px" }} />
            {t("Create New")}
          </button>
        )}
      </div>
      <hr />
      {showForm ? (
        <FtpIngestFormContainer
          {...props}
          setShowForm={setShowForm}
        />
      ) : (
        <FtpIngestRows
          {...props}
          ingestSources={ingestSources}
          setIngestSources={setIngestSources}
        />
      )}
    </div>
  );
};

export default FtpIngestManagement;
